import { render, staticRenderFns } from "./TransportTable.vue?vue&type=template&id=a5f22726"
import script from "./TransportTable.vue?vue&type=script&lang=ts"
export * from "./TransportTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports